import { IdName } from '.';

export class Church {
    id: string;
    country: IdName;
    displayName: string;
    isActive: boolean;
    isDeleted: boolean;
    isInterstate: boolean;
    state?: IdName;
    city?: string;
}
